export const TIME_CONSTANTS = {
  MINUTES_INCREMENT: 15,
  MIN_HOUR: 0,
  MAX_HOUR: 23,
  MIN_MINUTE: 0,
  MAX_MINUTE: 59,
  MINIMUM_LEAVE_DURATION_IN_HOURS: 0.25, // Minimum leave duration in hours, i.e. 1 hour, for 45 minutes, set to 0.75
} as const